<template>
  <el-container style="height: 100%">
    <el-header>
      <div class="logo-container float">
        <img src="../assets/images/logo7.png" />
        <!--        <img src="../assets/images/logo.png" alt="">-->
        <!-- <div>
          <img src="../assets/images/logo.png" />
        </div> -->
      </div>
      <div class="nav-row">
        <div v-if="language == 'zh-CN'" class="navBox">
          <div class="navBox-row" :style="'width:' + boxWidth + 'px'">
            <el-scrollbar ref="scrollContainer" :vertical="false" class="scroll-container tags"
              @wheel.native.prevent="handleScroll">
              <el-menu router :style="'transform: translateX(' + tabIndex + 'px);'" :default-active="activeIndex2"
                class="good_city" mode="horizontal" @select="handleSelect" background-color="#3a4255" text-color="#fff"
                active-text-color="#ffd04b">
                <el-menu-item class="tabBox" :id="'tab' + item.id" v-for="(item, index) in menuList" :key="index"
                  :index="item.path" @click="selectMenu(item, index)">{{ item.label }}<span v-if="[4, 8, 7].indexOf(item.id) > -1"
                    style="color: red">({{ item.count }})</span>
                    <span v-if="item.id == 11" style="color: red">({{ count }})</span>
                </el-menu-item>
              </el-menu>
            </el-scrollbar>
          </div>
        </div>
        <div v-else class="navBox">
          <div style="overflow: hidden" :style="'width:' + boxWidth + 'px'">
            <el-scrollbar ref="scrollContainer" :vertical="false" class="scroll-container tags"
              @wheel.native.prevent="handleScroll">
              <el-menu router :style="'transform: translateX(' + tabIndex + 'px);'" :default-active="activeIndex2"
                class="good_city" mode="horizontal" @select="handleSelect" background-color="#3a4255" text-color="#fff"
                active-text-color="#ffd04b">
                <el-menu-item class="tabBox" :id="'tab' + item.id" v-for="(item, index) in menuJpList" :key="index"
                  :index="item.path" @click="selectMenu(item, index)">{{ item.label }}<span v-if="[4, 8, 7].indexOf(item.id) > -1"
                    style="color: red">({{ item.count }})</span>
                    <span v-if="item.id == 11" style="color: red">({{ count }})</span>
                </el-menu-item>
              </el-menu>
            </el-scrollbar>
          </div>
        </div>

        <div class="contrlBox flexcenter">
          <i class="el-icon-arrow-left" @click="tabLeft"></i>
          <i class="el-icon-arrow-right" @click="tabRight"></i>
        </div>
      </div>

      <div class="header-right-contaienr float-right overflow" id="header-right-contaienr">
        <div class="call-me" @click="callMessage">{{ $t("createOrder.createOrder101") }}</div>
        <div class="price"> 1元={{hl}}円</div>
        <div class="float lx-mr10">
          <el-dropdown placement="bottom" :show-timeout="0">
            <span>{{ $t('_lang') }}</span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(val, key) in i18nMessages" :key="key" @click.native="changeLang(key)">{{ val._lang }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="float">
          <el-dropdown @command="setringItemClick">
            <span class="el-dropdown-link">
              <el-link :underline="false" class="el-icon-s-tools" style="font-size: 20px"> </el-link>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="item1">{{ $t('router.router8') }}</el-dropdown-item>
              <el-dropdown-item command="item2">{{ $t('router.router9') }}</el-dropdown-item>
              <el-dropdown-item command="item3">{{ $t('router.router14') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="float">
          <span class="el-dropdown-link">
            <el-badge is-dot v-if="btnReadFlag == 1"></el-badge>
            <el-link :underline="false" class="el-icon-message-solid" style="font-size: 20px" @click="message"> </el-link>
          </span>
        </div>
        <div class="float">
          <el-dropdown>
            <span class="el-dropdown-link userName"> {{ username }}<i class="el-icon-arrow-down el-icon--right"></i> </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-link type="info" @click="logout" :underline="false">{{ $t('logout') }}</el-link>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </el-header>

    <el-container>
      <el-main>
<!--        <keep-alive :include="catch_components">-->
          <router-view />
<!--        </keep-alive>-->
          <common-im /> 
      </el-main>
    </el-container>
    <!-- 全局消息弹窗 -->
    <el-dialog :title="$t('diaMsg.msg1')" :visible.sync="dialogVisibleMsg" center width="40%">
      <div v-if="activeItem">
        <div class="dia-content">
          <div class="dia-title-top">
            <span style="font-size: 18px">{{ activeItem.remindingTitle }}</span>
          </div>
          <div class="dia-title-mid">{{ activeItem.createTime | dateFormatToSecond }}</div>
          <div class="rich-text-content">
            <div v-html="activeItem.remindingContent"></div>
          </div>
          <!-- <div v-html="activeItem.remindingContent"></div> -->
        </div>
        <div class="dia-btnTop">
          <el-button class="dia-btnTop-Magin-left" type="primary" size="small" @click="read('')">{{ $t("diaMsg.msg2") }}</el-button>
          <el-button v-if="activeItem.messageGroupId && activeItem.createUserName !== 'system'" class="dia-btnTop-Magin" type="primary" size="small" @click="openMsg">{{ $t("diaMsg.msg3") }} </el-button>
          <el-button type="primary" size="small" @click="openDetails">{{ $t("diaMsg.msg4") }}</el-button>
        </div>
        <div class="dia-btnMid">
          <el-button plain type="primary" size="small" @click="jumpMassage">{{ $t("diaMsg.msg5") }}({{ unReadTotal }}) </el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div type="text" class="footer-left" @click="read('all')">{{ $t("diaMsg.msg6") }}</div>
        <div type="text" style="cursor: pointer" @click="dialogVisibleCloseMsg = true">{{ $t("diaMsg.msg7") }}</div>
      </span>
    </el-dialog>
    <!-- 回复 -->
    <el-dialog :title="$t('mess.mess51')" :visible.sync="replyDialogVisible" width="50%" @close="replyDialogClose">
      <message-form
        ref="messageFormRef"
        :message-group="messageDetailList"
        :info="activeItem"
        submit-url="cmUser/message2/reply"
        @refreshData="refreshData"
      />
      <div slot="footer" class="dialog-footer">
        <el-button class="search-btn btn-gray" @click="replyDialogClose">{{ $t("cancel") }}</el-button>
        <el-button class="search-btn btn-blue" @click="handleSend('messageFormRef')">{{ $t("loginR.login32") }}</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog :title="$t('mess.mess51')" :visible.sync="replyDialogVisible" width="50%" @close="replyDialogClose">
      <el-form :model="replyInfo" :rules="rules" ref="replyInfo" label-width="130px" class="demo-replyInfo">
        <el-form-item :label="$t('mess.mess23')">
          <span>{{typeDetailShow(msgList.messageType)}}</span>
        </el-form-item>
        <el-form-item :label="$t('mess.mess24')">
          <span>{{msgList.orderId}}</span>
        </el-form-item>
        <el-form-item :label="$t('mess.mess25')" prop="remindingTitle">
          <el-input v-model="replyInfo.remindingTitle" maxlength="100"></el-input>
        </el-form-item>

        <el-form-item :label="$t('mess.mess26')" prop="remindingContent">
          <quill-editor ref="text" v-model="replyInfo.remindingContent" :options="editorOption" />
        </el-form-item>
        <el-form-item :label="$t('mess.mess27')">
          <el-upload class="editor-slide-upload" :class="{hide:hideUploadEdit}"
            action="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com" :data="imgDataObj" :multiple="true"
            :file-list="replyInfo.imgFileList" :show-file-list="true" list-type="picture-card" :on-remove="handleImgRemove"
            :on-success="handleImgSuccess" :before-upload="beforeImgUpload" :limit="3">
            <el-button size="small" type="primary" class="btn">{{$t('mess.mess28')}}</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('createOrder.createOrder117')">
          <el-upload class="editor-slide-upload" :class="{hide:hideUploadEdit}" action="" :on-preview="handlePreview"
            :on-remove="handleRemove" :before-upload="beforeUploadFile" :before-remove="beforeRemove"
            :on-success="handleOrderInfo" multiple :show-file-list="true" :limit="1" :on-exceed="handleExceed"
            :file-list="fileList" :http-request="excelUploadRequest">
            <el-button class="search-btn btn-blue">{{ $t('createOrder.createOrder117') }}</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div style="text-align:right;">
        <el-button class="form-btn btn-gray" @click="replyDialogClose">{{$t('cancel')}}</el-button>
        <el-button class="form-btn btn-blue" @click="replySave('replyInfo')">{{$t('confirm')}}</el-button>
      </div>
    </el-dialog> -->
    <el-dialog :title="$t('detail')" :visible.sync="detailFlag" width="800px">
      <div v-if="activeId && messageDetailList.length" class="message-content-right">
        <div v-for="(item, index) in messageDetailList" class="message-list-item" :class="{ 'history-message-item': index !== 0 }">
          <h3 :class="{ 'first-title': index === 0 && item.createUserName !== 'system' && activeItem.isReply == 1 }">{{ item.remindingTitle }}</h3>
          <div class="send-info">
            <span>
              {{ `${$t("newMsg.mess47")}：` }}
              <span :style="{ color: '#fff', backgroundColor: prefixColor(item, 'createUserName'), padding: '0 5px' }">{{
                prefix(item, "createUserName")
              }}</span>
              <span :style="{ color: prefixColor(item, 'createUserName') }">{{
                prefix(item, "createUserName") === $t("recycle.recycle11") ? $t("newMsg.mess77") : item.createUserName
              }}</span>
            </span>
            <span>
              {{ `${$t("newMsg.mess67")}：` }}
              <span :style="{ color: '#fff', backgroundColor: prefixColor(item, 'remindingUserName'), padding: '0 5px' }">{{
                prefix(item, "remindingUserName")
              }}</span>
              <span :style="{ color: prefixColor(item, 'remindingUserName') }">{{
                prefix(item, "remindingUserName") === $t("recycle.recycle11") ? $t("newMsg.mess77") : item.remindingUserName
              }}</span>
            </span>
            <span>{{ `${$t("newMsg.mess20")}：${dataTimeFn(item.createTime)}` }}</span>
          </div>
          <div class="rich-text-content">
            <div v-html="item.remindingContent"></div>
          </div>
          <el-form label-width="130px" label-position="left" class="history-detail-form">
            <el-form-item label-width="0px">
              <el-col :span="8">
                <el-form-item :label="`${$t('newMsg.mess19')}：`">
                  <span class="under-text primary-text" @click="toOrderDetail(item)">
                    {{ item.orderId || $t("newMsg.mess68") }}
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="2">
                <el-form-item :label="`${$t('newMsg.mess69')}：`">
                  <span class="under-text primary-text" @click="toFBA">{{ item.containerBatchNo || $t("newMsg.mess68") }}</span>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item :label="`${$t('newMsg.mess45')}：`">
              <div v-if="item.fileModels && item.fileModels.length" class="annex-list">
                <div class="annex-list-item" v-for="annex in item.fileModels">
                  <span class="under-text primary-text file-name text-overflow" @click="downloadFile(annex.fileName, annex.filePath)">{{
                    annex.fileName
                  }}</span>
                  <span class="under-text primary-text" @click="downloadFile(annex.fileName, annex.filePath)">{{
                    $t("orderList.orderList147")
                  }}</span>
                </div>
              </div>
              <span v-else class="under-text primary-text">{{ $t("newMsg.mess68") }}</span>
            </el-form-item>
          </el-form>
          <div class="history-text" v-if="messageDetailList.length > 1 && index === 0">{{ $t("newMsg.mess70") }}</div>
        </div>
        <div class="send-list-operate">
          <el-button v-if="activeItem.messageGroupId && activeItem.createUserName !== 'system'" size="small" class="search-btn btn-blue" @click="openMsg">{{ $t("newMsg.mess79") }}</el-button>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-blue" @click="detailFlag = false">{{ $t("confirm") }}</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog :title="$t('detail')" :visible.sync="detailFlag" width="1200px">
      <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="firstList" border>
        <el-table-column :label="$t('handle')" align="center" width="120">
          <template v-slot="scope">
            <div class="btn-row">
              <el-button class="list-btn btn-green" @click="reply(scope.row)"
                v-if="btnReplyFlag == scope.row.replyFlag&&scope.row.createUserName!='system'">
                {{$t('mess.mess15')}}
              </el-button>
            </div>
            <div class="btn-row">
              <el-button class="list-btn btn-blue" @click="read(scope.row)" v-if="btnReadFlag ==scope.row.isRead">
                {{$t('mess.mess10')}}
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="replyFlag" :index="indexMethod" align="center" width="70" :label="$t('mess.mess16')">
          <template v-slot="scope">
            <span v-if="scope.row.replyFlag==1">{{ replyStatusShow(scope.row.replyFlag) }}</span>
            <span v-else-if="scope.row.isRead==1">{{ readStatusShow(scope.row.isRead) }}</span>
            <span v-else>{{ readStatusShow(scope.row.isRead) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remindingTitle" width="200" :label="$t('mess.mess21')">
        </el-table-column>
        <el-table-column width="300" :label="$t('mess.mess22')">
          <template v-slot="scope">
            <div v-html="scope.row.remindingContent"></div>
          </template>
        </el-table-column>
        <el-table-column prop="replyPicture" align="center" :label="$t('mess.mess17')">
          <template slot-scope="scope">
            <img @click="imgclick(scope.row.replyPicture,true)" v-if="scope.row.replyPicture&&scope.row.replyPicture.length>0"
              :src="scope.row.replyPicture" alt="" class="list-image">
            <img v-else src="../assets/images/default.png" alt="" class="list-image">
          </template>
        </el-table-column>
        <el-table-column prop="fileName" :label="$t('mess.mess45')">
          <template v-slot="scope">
            <a target="_blank" :href="scope.row.filePath">{{scope.row.fileName}}</a>
          </template>
        </el-table-column>
        <el-table-column prop="orderId" align="center" :label="$t('mess.mess19')">
          <template v-slot="scope">
            <el-link v-if="scope.row.messageType=='1'  || scope.row.messageType== 1" style="color:black"
              @click="toOrderDetail(scope.row)" :underline="false">{{scope.row.orderId}}
            </el-link>
            <span v-else style="color:black">{{scope.row.orderId}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" align="center" :index="indexMethod" :label="$t('mess.mess20')">
          <template v-slot="scope">
            {{ scope.row.createTime | dateFormatToSecond }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="messageType" :label="$t('mess.mess18')">
          <template v-slot="scope">
            {{ typeDetailShow(scope.row.messageType) }}
          </template>
        </el-table-column>
      </el-table>
      <div class="title">{{$t('mess.mess46')}}</div>
      <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="historyMessageList" border
        height="550px">
        <el-table-column prop="sender" width="120" align="center" :label="$t('mess.mess47')">
          <template v-slot="scope">
            <span v-if="scope.row.sender==1">{{$t('mess.mess49')}}</span>
            <span v-if="scope.row.sender==0">{{$t('mess.mess48')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="replyFlag" :index="indexMethod" align="center" width="70" :label="$t('mess.mess16')">
          <template v-slot="scope">
            <span v-if="scope.row.replyFlag==1">{{ replyStatusShow(scope.row.replyFlag) }}</span>
            <span v-else-if="scope.row.isRead==1">{{ readStatusShow(scope.row.isRead) }}</span>
            <span v-else>{{ readStatusShow(scope.row.isRead) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remindingTitle" width="200" :label="$t('mess.mess21')">
        </el-table-column>
        <el-table-column width="300" :label="$t('mess.mess22')">
          <template v-slot="scope">
            <div v-html="scope.row.remindingContent"></div>
          </template>
        </el-table-column>
        <el-table-column prop="replyPicture" align="center" :label="$t('mess.mess17')">
          <template slot-scope="scope">
            <img @click="imgclick(scope.row.replyPicture,true)" v-if="scope.row.replyPicture&&scope.row.replyPicture.length>0"
              :src="scope.row.replyPicture" alt="" class="list-image">
            <img v-else src="../assets/images/default.png" alt="" class="list-image">
          </template>
        </el-table-column>
        <el-table-column prop="fileName" :label="$t('mess.mess45')">
          <template v-slot="scope">
            <a target="_blank" :href="scope.row.filePath">{{scope.row.fileName}}</a>
          </template>
        </el-table-column>
        <el-table-column prop="orderId" align="center" :label="$t('mess.mess19')">
          <template v-slot="scope">
            <el-link style="color:black" v-if="scope.row.messageType=='1' || scope.row.messageType== 1"
              @click="toOrderDetail(scope.row)" :underline="false">{{scope.row.orderId}}
            </el-link>
            <span v-else style="color:black">{{scope.row.orderId}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" align="center" :index="indexMethod" :label="$t('mess.mess20')">
          <template v-slot="scope">
            {{ scope.row.createTime | dateFormatToSecond }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="messageType" :label="$t('mess.mess18')">
          <template v-slot="scope">
            {{ typeDetailShow(scope.row.messageType) }}
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align:right;margin-top:15px">
        <el-button class="form-btn btn-blue" @click="detailFlag=false">{{$t('confirm')}}</el-button>
      </div>
    </el-dialog> -->
    <!-- 关闭消息提醒 -->
    <el-dialog :title="$t('diaCloseMsg.msg1')" center :visible.sync="dialogVisibleCloseMsg" width="40%">
      <div class="dia-content">{{$t('diaCloseMsg.msg2')}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="dialogVisibleCloseMsg = false">{{$t('diaCloseMsg.msg4')}}</el-button>
        <el-button type="primary" @click="closeMsg">{{$t('diaCloseMsg.msg3')}}</el-button>
      </span>
    </el-dialog>
    <!-- 联系我们 -->
    <ms-dialog ref="msDialogRef"></ms-dialog>
  </el-container>
</template>

<script>
import { mapState } from 'vuex';
import { messages, setLang } from '@/i18n';
import { dataTimeFn, prefix, prefixColor } from "../assets/js/utils";
import MessageForm from "@/components/newMessage/components/messageForm.vue";
import MsDialog from '../components/newMessage/components/msDialog.vue';
import commonIm from "../views/im/index.vue";
import Oss from '../assets/js/oss'
const toolbarOptions = [
  ['bold'], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
]
// import Cookies from 'js-cookie'
export default {
  components: {
    commonIm,
    MsDialog,
    MessageForm
  },
  data () {
    return {
      dialogVisibleMsg: false,
      replyDialogVisible: false, // 消息回复
      detailFlag: false, //详情
      hideUploadEdit: false,
      dialogVisibleCloseMsg: false, //关闭弹窗提醒
      tabChose: 1, //选择的tab
      tabIndex: 0, //tab需要移动的宽
      i18nMessages: messages,
      orderTableData: {
        arrivalCount: 0,
        categoryCount: 0,
        badOrderCount: 0
      },
      iconObj: {
        1: 'iconfont icon-icon_user',
        2: 'iconfont icon-tijikongjian',
        11: 'iconfont icon-shangpin',
        21: 'iconfont icon-danju',
        22: 'iconfont icon-baobiao'
      },
      isCollapse: false,
      activeIndex2: '',
      // menulist: [],
      // menuJpList: [],
      unReadCount: 0,
      btnReadFlag: 0,
      count: 0,
      hl: 0,
      timer: '',
      value: 0,
      username: '',
      // langFlag1:this.language=='ja-JP',
      screenWidth: document.body.clientWidth,
      boxWidth: 0,
      rightWidth: 200,
      msgList: "",
      replyInfo: {
        remindingContent: '',
        remindingTitle: '',
        replyPicture: '',
        imgFileList: [],
        imgFileListStr: ''
      },
      replyMessageInfo: {},  //回复页面显示表格所在行内容
      listObj: [],
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions,
          }
        }
      },
      imgDataObj: {
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: '',
        timeStamp: '',
      },
      fileList: [],
      rules: {
        remindingTitle: [
          { required: true, message: this.$t('mess.mess29'), trigger: 'blur' }
        ],
        remindingContent: [
          { required: true, message: this.$t('mess.mess30'), trigger: 'blur' }
        ]
      },
      firstList: [],
      historyMessageList: [],
      btnReplyFlag: 0,
      messageStatusList: [],
      dataTimeFn,
      messageDetailList: [],
      activeId: "",
      sysMsgId: "",
      activeItem: null,
      unReadTotal: 0,
      prefix,
      prefixColor
    };
  },
  computed: {
    ...mapState({
      // 从 state 中的到的计算属性
      menuList: (state) => state.menuList,
      menuJpList: (state) => state.menuJpList,
      language: (state) => state.language,
      activePath: (state) => state.activePath, // 已选中菜单
      tabList: (state) => state.tabList, // tags菜单列表
      catch_components: (state) => state.catch_components // keepalive缓存
    }),
    scrollWrapper () {
      return this.$refs.scrollContainer.$refs.wrap;
    }
  },
  methods: {
    downloadFile(name, url) {
      let formdata = new FormData();
      formdata.append("FileUrl", url);
      formdata.append("FileName", name);
      this.$http({
        url: "aliyun/oss/newDownload",
        method: "post",
        data: formdata,
        responseType: "blob", //关键点
      }).then((res) => {
        //下载文件操作
        const link = document.createElement("a");
        let blob = new Blob([res.data], { type: "" }); //生成blob对象
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", name); //下载的文件名以及文件格式
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    callMessage() {
      this.$refs.msDialogRef.showMessageDialog()
    },
    jumpMassage () {
      this.$router.push({ path: 'message' });
      this.dialogVisibleMsg = false
      this.detailFlag = false //详情
    },
    // toOrderDetail (row) {
    //   console.log(row, 'row');
    //   if (row.orderId.indexOf('R') != -1 || row.orderId.indexOf('C') != -1) { //R出现或者C出现
    //     this.$router.push({     //充值记录
    //       name: 'RechargeList',
    //       query: {
    //         rechargeNo: row.orderId
    //       }
    //     })
    //   } else {                  //订单详情
    //     this.$router.push({
    //       name: 'orderDetail',
    //       query: {
    //         id: row.orderId,
    //         isEdit: '0'
    //       }
    //     })
    //   }
    //   this.dialogVisibleMsg = false
    //   this.detailFlag = false //详情
    // },
    toOrderDetail(row) {
      if (row.orderId) {
        this.$http
          .get("/cmUser/message2/orderIsExist", { params: { orderId: row.orderId } })
          .then(({ data: res }) => {
            if (res.code === 200) {
              if (!res.data) {
                this.$message.warning(this.$t("newMsg.mess80"));
              } else {
                if (row.orderId.indexOf("R") != -1 || row.orderId.indexOf("C") != -1) {
                  //R出现或者C出现
                  this.$router.push({
                    //充值记录
                    name: "rechargeList",
                    query: {
                      rechargeNo: row.orderId,
                    },
                  });
                } else {
                  //订单详情
                  this.$router.push({
                    name: "orderDetail",
                    query: {
                      id: row.orderId,
                      isEdit: "0",
                    },
                  });
                }
              }
            }
          })
          .catch(() => {
            this.$message.warning(this.$t("newMsg.mess81"));
          });
      } else {
        // 订单列表
        this.$router.push("orderList");
      }
      this.dialogVisibleMsg = false;
      this.detailFlag = false; //详情
    },
    readStatusShow (status) {
      switch (status) {
        case '1':
          return this.$t('mess.mess10')
          break;
        default:
          return this.$t('mess.mess9')
          break;
      }
    },
    replySave (formName) {    //保存回复内容按钮
      console.log(this.replyInfo)
      this.msgList

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addReply(this.msgList.id);
          this.replyDialogVisible = false;
          this.btnReplyFlag == 0;
        } else {
          this.$message.error(this.$t('mess.mess37'));
          return false;
        }
      });
    },
    // async read () {    //已读
    //   var url = 'cmUser/message/readOne';
    //   const { data: res } = await this.$http.post(url, { id: this.msgList.id });
    //   if (res.code == 200) {
    //     this.$message({
    //       type: 'success',
    //       message: res.message
    //     })
    //   } else {
    //     this.$message({
    //       type: 'warning',
    //       message: res.message
    //     })
    //   }
    //   this.dialogVisibleMsg = false
    // },
    // async readAll () {    //全部已读
    //   var url = 'cmUser/message/readAll';
    //   const { data: res } = await this.$http.post(url, {});
    //   if (res.code == 200) {
    //     this.$message({
    //       type: 'success',
    //       message: res.message
    //     })
    //   } else {
    //     this.$message({
    //       type: 'warning',
    //       message: res.message
    //     })
    //   }
    //   this.dialogVisibleMsg = false
    //   this.btnReadFlag = 0;
    // },
    handleSend(refName) {
      // 回复框展开时的发送按钮
      this.$refs[refName].submit();
    },
    async read(remindingUserName) {
      const { id, messageGroupId } = this.activeItem;
      const { data: res } = await this.$http.get("cmUser/message2/isRead", {
        params: {
          id,
          messageGroupId,
          remindingUserName,
        },
      });
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.message,
        });
      } else {
        this.$message({
          type: "warning",
          message: res.message,
        });
      }
      this.dialogVisibleMsg = false;
      if (remindingUserName === "all") {
        this.btnReadFlag = 0;
        this.count = 0;
      }
    },
    async closeMsg () {    //关闭消息提醒
      var url = 'email/reminding/closeReminding';
      const { data: res } = await this.$http.post(url, {});
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: res.message
        })
      } else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
      this.dialogVisibleMsg = false;
      this.dialogVisibleCloseMsg = false;
      this.btnReadFlag = 0;
    },
    async addReply () {    //添加回复
      this.handleImgSubmit();
      var url = 'cmUser/message/reply';
      this.replyInfo.messageType = this.msgList.messageType
      this.replyInfo.orderId = this.msgList.orderId
      this.replyInfo.id = this.msgList.id
      const { data: res } = await this.$http.post(url, this.replyInfo);
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: res.message
        })
        this.dialogVisibleMsg = false;
      } else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }

      if (this.detailFlag) {
        const { data: res } = await this.$http.get('cmUser/message/queryMessageInfo/' + this.id);
        this.historyMessageList = res.data
        let arr = []
        arr.push(res.data[0])
        this.firstList = arr
      }
    },
    // async handleDetail () {
    //   this.id = this.msgList.id
    //   const { data: res } = await this.$http.get('cmUser/message/queryMessageInfo/' + this.msgList.id);
    //   this.historyMessageList = res.data
    //   console.log(this.historyMessageList, 'historyMessageList');
    //   let arr = []
    //   arr.push(res.data[0])
    //   this.firstList = arr
    //   this.detailFlag = true
    // },
    async getRightDetail() {
      this.$http.get(`cmUser/message/popUp/${this.activeId}`).then(({ data: res }) => {
        if (res.code === 200 && res.data) {
          this.messageDetailList = res.data.length ? [res.data[0]] : [];
        } else {
          this.messageDetailList = [];
        }
      });
    },
    toFBA() {
      this.$router.push("/fba");
      this.dialogVisibleMsg = false
      this.detailFlag = false //详情
    },
    refreshData() {
      this.replyDialogVisible = false;
    },
    openMsg () { //开启回复弹窗
      this.replyDialogVisible = true
    },
    openDetails () {
      this.detailFlag = true
      // this.handleDetail()
    },
    replyDialogClose () {    //关闭回复弹窗
      this.replyDialogVisible = false;
      this.$refs.messageFormRef.formReset();
    },
    typeDetailShow (status) {
      switch (status) {
        case '1':
          return this.$t('mess.mess31')
          break;
        case '2':
          return this.$t('mess.mess32')
          break;
      }
    },
    reply (row) {     //回复
      this.handleImgSubmit();
      this.replyDialogVisible = true;
      this.fileList = []
      this.hideUploadEdit = false
      this.replyMessageInfo = row;
      this.replyInfo = {
        id: row.id,
        imgFileList: []
      };
    },
    handlePreview () {
      // console.log(file);
    },
    handleExceed (files, fileList) {
      this.$message.warning(
        `${this.$t('createOrder.createOrder91')}，${this.$t('createOrder.createOrder92')} ${files.length} ${this.$t('createOrder.createOrder93')}，${this.$t('createOrder.createOrder94')} ${files.length + fileList.length
        } ${this.$t('createOrder.createOrder93')}`
      );
    },
    beforeUploadFile (file) {
      const extension = file.name.substring(file.name.lastIndexOf('.'))
      console.log(extension)
      // const size = file.size / 1024 / 1024
      if (extension !== '.xls' && extension !== '.xlsx' && extension !== '.pdf') {
        this.$message.warning('只能上传excel和pdf文件')
        return false
      }
      // if (size > 10) {
      //   this.$message.warning('文件大小不得超过10M')
      // }
    },
    // 批量导入
    async excelUploadRequest (file) {
      let formdata = new FormData();
      formdata.append('file', file.file);
      const { data: res } = await this.$http.post('cmUser/message/uploadFile', formdata);
      if (res.code === 200) {
        this.replyInfo.fileName = res.data.fileName
        this.replyInfo.filePath = res.data.filePath
      }
    },
    beforeRemove () {
      // return this.$confirm(`${this.$t('orderList.orderList107')} ${file.name}？`);
    },
    // 批量导入成功回调
    handleOrderInfo () {
      console.log('success')
      // console.log(data)
    },
    imgclick (url) {
      this.visible = true
      this.imgurl = url
    },
    showImgDialog () {
      this.imgDialogVisible = true;
    },
    handleImgRemove (file) {
      Oss.imgRemove(file, this.listObj);
      this.hideUploadEdit = false
    },
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    handleImgSuccess (response, file) {
      Oss.imgSuccess(file, this.listObj, this.imgDataObj);
      this.hideUploadEdit = true
    },
    handleRemove () {
      this.replyInfo.fileName = ''
      this.replyInfo.filePath = ''
    },
    beforeImgUpload (file) {
      console.log(file);
      const _self = this;
      const fileName = file.uid;
      console.log(fileName);
      this.listObj[fileName] = {};
      return new Promise((resolve, reject) => {
        _self.$http.get('aliyun/oss/policy').then(response => {
          var num = "";   //定义编号
          for (var i = 0; i < 4; i++) //4位随机数，用以加在时间戳后面。
          {
            num += Math.floor(Math.random() * 10);
          }
          num = new Date().getTime() + num;  //时间戳，用来生成编号。
          _self.imgDataObj.policy = response.data.data.policy;
          _self.imgDataObj.signature = response.data.data.signature;
          _self.imgDataObj.ossaccessKeyId = response.data.data.accessKeyId;
          _self.imgDataObj.key = response.data.data.dir + '/inBox/' + num + '${filename}';
          _self.imgDataObj.dir = response.data.data.dir + '/inBox';
          _self.imgDataObj.host = response.data.data.host;
          _self.imgDataObj.timeStamp = num;
          file.timeStamp = num
          Oss.imgCompress(file, this.listObj, resolve, reject)
        }).catch(err => {
          console.log(err)
          reject(false)
        })
      })
    },
    handleImgSubmit () {
      var _this = this;
      const arr = Object.keys(_this.listObj).map(v => _this.listObj[v]);
      if (!Oss.checkAllSuccess(_this.listObj)) {
        _this.$message(this.$t('mess.mess35'))
        return
      } else {
        if (arr.length > 1) {
          _this.$message.error(this.$t('mess.mess36'));
        } else {
          _this.replyInfo.imgFileList = _this.replyInfo.imgFileList.concat(arr);
          var urlArr = [];
          _this.replyInfo.imgFileList.forEach(el => {
            urlArr.push(el.url);
          })
          _this.replyInfo.replyPicture = urlArr.toString();
          _this.$emit('successCBK', arr);
          _this.listObj = {};
          _this.imgDialogVisible = false;

        }
      }
    },
    handleScroll (e) {
      const eventDelta = e.wheelDelta || -e.deltaY * 40;
      const $scrollWrapper = this.scrollWrapper;
      $scrollWrapper.scrollLeft = $scrollWrapper.scrollLeft + eventDelta / 4;
    },
    async queryJpyExchangeRate () {
      await this.$http.get("exchangeRate/queryJPYExchangeRate", {}).then(res => {
        this.hl = res.data.data.exchangeRate;
      })
    },
    tabLeft () {
      this.$refs.scrollContainer.wrap.scrollLeft += -100;
    },
    tabRight () {
      this.$refs.scrollContainer.wrap.scrollLeft += 100;
    },

    changeLang (key) {
      location.reload();
      this.$i18n.locale = key;
      setLang(key);
    },
    logout () {
      window.sessionStorage.clear();
      this.$router.push({
        name: 'login'
      });
    },
    setringItemClick (command) {
      if (command == 'item1') {
        this.$router.push({
          name: 'personalData'
        });
      }
      if (command == 'item2') {
        this.$router.push({
          name: 'accountSecurity'
        });
      }
      if (command == 'item3') {
        this.$router.push({
          name: 'reminderSetting'
        });
      }
    },
    message () {
      this.$router.push({
        name: 'message'
      });
    },
    handleSelect () {
      // this.activeIndex2 = key;
    },
    async getUnReadCount () {
      const { data: res } = await this.$http.get('cmUser/message2/unReadCount', {});
      this.count = res.data;
      if (res.data == 0) {
        this.btnReadFlag = 0; //=1展示
      } else {
        this.btnReadFlag = 1; //=0不展示
      }
    },
    async getUserInfo () {
      const { data: res } = await this.$http.get('admin/info');

      //用户名放入session
      sessionStorage.setItem('username', res.data.username);
      this.username = sessionStorage.getItem('username');

      // 0 关闭  1 开启
      console.log(res.data.remindingFlag, 'res.data.remindingFlag');
      if (res.data.remindingFlag == '1') {
        // this.queryNotReadMessage()
        this.getMessageList();
      } else {
        this.dialogVisibleMsg = false;
      }

      this.$nextTick(() => {
        this.rightWidth = document.getElementById('header-right-contaienr').clientWidth;
        console.log(this.rightWidth);
      });
    },
    // async queryNotReadMessage () {
    //   const { data: res } = await this.$http.get('cmUser/message/queryNotReadMessage', {});
    //   console.log(res.data.id, 'res```111');
    //   // res.data.id = 123
    //   if (res.data.id != null) {
    //     this.dialogVisibleMsg = true;
    //   }
    //   this.msgList = res.data
    // },
    getMessageList() {
      //获取信息列表
      this.$http
        .get("/cmUser/message2/list", {
          params: {
            pageSize: 1,
            pageNum: 1,
            isRead: 0,
          },
        })
        .then(({ data: res }) => {
          if (res.code === 200 && res.data && res.data.list) {
            if (!res.data.list.length) {
              this.messageDetailList = [];
            } else {
              this.unReadTotal = res.data.total;
              this.activeItem = res.data.list[0] || null;
              this.activeId = res.data.list[0].id || "";
              this.dialogVisibleMsg = true;
              this.getRightDetail();
            }
          }
        });
    },
    async getOrderTableCount () {
      this.$store.dispatch('setOrderCount');
    },

    // 点击菜单 - 传入name，添加到keepalive缓存页面
    selectMenu (item) {
      // 加入keepalive缓存
      this.$store.commit('addKeepAliveCache', item.name);
      if (item.name != 'orderList') this.$store.commit('removeKeepAliveCache', 'orderList');
      this.$store.commit('selectMenu', item);
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  mounted () {
    this.screenWidth = document.body.clientWidth;
    this.queryJpyExchangeRate()
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
  },
  created () {
    this.getOrderTableCount();
    this.getUnReadCount();
    this.timer = setInterval(() => {
      this.getUnReadCount();
    }, 10000);
    this.getUserInfo();
    // if(this.$route.path !='/index'){
    // this.activeIndex2 = this.$route.path;
    // }
    this.activeIndex2 = this.$route.path.substring(1);
    // console.log(this.$router.options.routes[0].children);
    this.$router.options.routes[0].children.forEach((el) => {
      if (el.path == this.activeIndex2.split('?')[0]) {
        // this.$store.state.tabList.push(el);
        this.$store.commit('selectMenu', el);
      }
    });
  },
  watch: {
    $route: function () {
      this.activeIndex2 = this.$route.path.substring(1);
      this.$router.options.routes[0].children.forEach((el) => {
        if (el.path == this.activeIndex2) {
          // this.$store.state.tabList.push(el);
          this.$store.commit('selectMenu', el);
        }
      });
    },
    screenWidth: {
      handler: function (val) {

        if (val < 1500) {
          this.boxWidth = val - this.rightWidth - 500;

        } else {
          this.boxWidth = val - this.rightWidth - 600;
        }

      },
      immediate: true
    }
    //   language: {
    //   handler: function (newVal) {
    //         this.langFlag1 = newVal
    //   },
    //   deep: true,
    //   immediate: true
    // }
  }
};
</script>
<style scoped lang="less">
/deep/ .el-scrollbar__wrap {
  overflow-x: scroll;
  margin-right: 0px !important;
  // overflow: auto;
  overflow-y: hidden;
}
.nav-row {
  float: left;
}
.navBox-row {
  overflow-x: scroll;
}
.navBox {
  overflow: hidden;
  float: left;
  .tabBox {
    flex-shrink: 0;
    float: left;
  }
  .tabBox:hover {
    cursor: pointer;
  }
  .good_city {
    display: flex;
    flex-wrap: nowrap;
    width: 1100px;
    transition: all 0.5s;
  }
}
.contrlBox {
  float: left;
  width: 50px;
  margin-top: 16px;
  i {
    font-size: 18px;
    flex-wrap: bold;
    float: left;
  }
  i:hover {
    cursor: pointer;
  }
}
</style>

<style lang="less" scoped>
.text-overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rich-text-content {
  margin: 15px 0;
  padding: 50px 15px;
  background: #f2f2f2;
  ::v-deep img {
    max-width: 100%;
  }
}
.send-message-wrap {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s;
}
.message-list-item {
  border-bottom: 3px solid #ccc;
  padding-bottom: 20px;
  position: relative;
  .history-detail-form {
    ::v-deep .el-form-item {
      margin-bottom: 0;
    }
  }
  .history-text {
    position: absolute;
    left: 50%;
    bottom: -20px;
    background: #fff;
    transform: translateX(-50%);
    padding: 10px;
  }
  h3 {
    font-size: 14px;
    margin: 10px 0;
  }
  .send-info {
    display: flex;
    background-color: #fff;
    line-height: 50px;
    gap: 35px;
  }
  .association {
    display: flex;
    gap: 35px;
  }
  .annex-list {
    width: 54%;
    .annex-list-item {
      display: flex;
      justify-content: space-between;
      height: 28px;
      .file-name {
        max-width: 70%;
      }
    }
  }
}
.send-list-operate {
  position: absolute;
  top: -26px;
  right: -10px;
}
.message-content-right {
  position: relative;
}
.under-text {
  text-decoration: underline;
  cursor: pointer;
}
.primary-text {
  color: #3e8ef7;
}
.el-header {
  background-color: #3a4255;
  // display: flex;
  // justify-content: space-between;
  // padding-left: 0;
  // align-items: center;
  padding: 0 0 0 20px;
  color: #fff;
  font-size: 20px;
  // > div {
  //   display: flex;
  //   align-items: center;
  //   span {
  //     margin-left: 15px;
  //   }
  // }
  height: 50px !important;
  line-height: 50px !important;
  img {
    width: 174px;
    height: 32px;
  }
}
.price {
  float: left;
  margin-right: 10px;
  color: #f59a23;
}
.call-me {
  float: left;
  margin-right: 10px;
  cursor: pointer;
}
.logo-container {
  height: 50px;
  width: 190px;
  padding: 10px 0;
}
.logo-container div {
  background-color: white;
  height: 50px;
  position: relative;
  top: -10px;
  left: -20px;
  padding-top: 9px;
  padding-left: 19px;
  width: 258px;
}
.el-menu--horizontal > .el-menu-item {
  height: 50px;
  line-height: 50px;
}
.el-main {
  overflow: hidden;
  background-color: #eaedf1;
  padding: 15px !important;
}
.iconfont {
  margin-right: 10px;
}
.toggle-button {
  background-color: #4a5064;
  font-size: 10px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.2em;
  cursor: pointer;
}
.el-menu--horizontal > .el-menu-item.is-active {
  // border-bottom: 2px solid #ffffff !important;
  background-color: #2e85a1 !important;
  color: #ffffff !important;
  border: none;
}
.el-menu-item {
  border: none;
}
.el-menu--horizontal > .el-menu-item {
  background-color: #3a4255 !important;
}
.el-dropdown {
  color: #fff;
}
.el-menu-item {
  padding: 0 13px !important;
}

.el-link.el-link--default {
  color: #fff !important;
}
.el-dropdown:hover {
  cursor: pointer;
}
.el-menu-item {
  user-select: none;
}
.el-tags-container {
  width: 100%;
  height: 30px;
  line-height: 30px;
}

.el-dropdown-link,
.el-dropdown-link a,
.userName {
  display: inline-block;
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border: none;
}
.el-dropdown-link,
.userName {
  padding: 0 10px;
}
.el-dropdown-link:hover {
  background-color: #2e85a1 !important;
  cursor: pointer;
}
.userName:hover {
  background-color: #2e85a1 !important;
}
.el-dropdown-link {
  position: relative;
}
/deep/.el-badge {
  position: absolute;
  left: 5px;
  top: 0;
}
/deep/.el-badge__content {
  border: none !important;
}

// tab页
.tabs-switch-page {
  display: flex;
  align-items: center;
  height: 40px;
  background-color: #fff;
  overflow: hidden;
}
.el-tag {
  cursor: pointer;
  margin-left: 10px;
  border-radius: 2px;
  font-size: 12px;
  color: #1890ff;
  border-color: #1890ff;
}
.el-tag--dark {
  color: #fff;
  background-color: #1890ff;
}

.el-dropdown-link {
  cursor: pointer;
}
.el-icon-arrow-down {
  font-size: 12px;
}
// .el-menu{
//   width:1000px;
//   overflow-x: scroll;
//   white-space: nowrap;
//   display:flex;
// }
// .el-menu::-webkit-scrollbar{
//   display:none;/*隐藏滚动条*/
// }
</style>

<style>
.dia-btnTop {
  margin-top: 40px;
  text-align: center;
}
.dia-btnTop-Magin-left {
  margin-right: 10px;
}
.dia-btnTop-Magin {
  margin-right: 10px;
}
.dia-content {
  padding: 0 40px;
}
.dia-title-top {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 20px;
}
.dia-title-mid {
  color: #909399;
  margin-bottom: 20px;
}

.dia-btnMid {
  margin-top: 33px;
  text-align: center;
}
.dialog-footer {
  display: flex;
  justify-content: center;
  color: #409eff;
}
.footer-left {
  margin-right: 40px;
  cursor: pointer;
}
.el-link--inner {
  color: #606266;
}
</style>


<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}

.el-table .el-button--small {
  padding: 4px 10px;
}

.upload-container .editor-slide-upload {
  margin-bottom: 20px;
}
.title {
  font-weight: bold;
  font-size: 18px;
  text-align: left;
  margin: 15px 0;
}
.btn {
  width: 120px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  height: auto;
  overflow: hidden;
}
.hide /deep/ .el-upload--picture-card {
  display: none;
}
</style>
